import type { CareerCenter } from "@/modules/careerCenter/types"
import type { JobAd } from "@/modules/jobAds/client/api/types"

export const computeIsPostedByPartnerCompany = (
  legacyPartnerSchoolIds: JobAd["legacyPartnerSchoolIds"],
  dataCareerCenter: CareerCenter | undefined
): boolean => {
  if (!dataCareerCenter) return false
  if (legacyPartnerSchoolIds.length === 0) return false

  return (
    legacyPartnerSchoolIds.includes(dataCareerCenter.id) ||
    legacyPartnerSchoolIds.includes(Number(dataCareerCenter.idOld)) ||
    legacyPartnerSchoolIds.includes(dataCareerCenter?.mainCareerCenterId || "")
  )
}
